import { Currency, formatCurrency } from '@ps/web-poker-utils';

import { getActiveGameIds, mapActiveGames } from './activeGames';
import {
  GameCategoryTypeToLabel,
  KnockoutType,
  Speed,
  Structure,
  getKnockoutType,
  isKnockout,
  isZoom
} from './formatters/game';
import mapMttTypes, { mttUtils } from './mapMttTypes';
import mapPPPTypes from './mapPPPTypes';
import mapSagGames from './mapSagGames';
import mapSagTypes from './mapSagTypes';
import mapSeatFinderTypes from './mapSeatFinderTypes';
import mapSngTypes from './mapSngTypes';
import mapTableTypes from './mapTableTypes';
import mapZoomTypes from './mapZoomTypes';
import type { MapRawDataType, MappedRawData, Options } from './types';
import { GameCategoryTypes } from './types';
import { distinct } from './utils';
import { MT_STATUS } from './utils/mtt.types';
import { formatTimeAttribute } from './utils/timeDisplay';

export * from './types';
export * from './formatters/types';

export const POKER_TILE_IMAGES_BASE_URL = 'https://thehub.rationalcdn.com/pokerTileImages';

const defaults: Options = {
  language: 'en',
  disabledGameTypes: [],
  hspFlagsMap: {},
  isPPPRevampNeymar: false
};

export const mapRawData = (
  { tourns, tableTypes, sngTypes, sagTypes, zoomTypes, seatFinders, pppTypes }: MapRawDataType,
  options: Options = defaults
) => {
  const { disabledGameTypes } = { ...defaults, ...options };

  const mappers = {
    tourns: mapMttTypes(tourns, options),
    tableTypes: mapTableTypes(tableTypes, options),
    sngTypes: mapSngTypes(sngTypes, options),
    sagTypes: mapSagTypes(sagTypes, options),
    zoomTypes: mapZoomTypes(zoomTypes, options),
    seatFinders: mapSeatFinderTypes(seatFinders, options),
    pppTypes:
      pppTypes && !disabledGameTypes.includes(GameCategoryTypes.PPP)
        ? mapPPPTypes(pppTypes, options)
        : []
  };

  return Object.entries(mappers).reduce((acc, [key, value]) => {
    // @ts-ignore TODO: add proper typings
    acc[key] = distinct(value);

    return acc;
  }, {}) as MappedRawData;
};

export const mappers = {
  mapMttTypes,
  mapTableTypes,
  mapSagTypes,
  mapSngTypes,
  mapZoomTypes,
  mapSeatFinderTypes,
  mapPPPTypes,
  mapSagGames,
  mapActiveGames,
  getActiveGameIds
};

export const utils = {
  mttUtils,
  formatCurrency,
  formatTimeAttribute
};

export {
  GameCategoryTypeToLabel,
  Structure,
  Speed,
  MT_STATUS,
  Currency,
  isKnockout,
  isZoom,
  getKnockoutType,
  KnockoutType
};
